export const getTopLevelDomain = (url: string): string => {
  try {
    const urlObj = new URL(url)
    const parts = urlObj.hostname.split('.')
    return parts.slice(-2).join('.')
  } catch (e) {
    return url
  }
}
